import { render } from "./ContactSection.vue?vue&type=template&id=3d10ac53&scoped=true"
import script from "./ContactSection.vue?vue&type=script&lang=js"
export * from "./ContactSection.vue?vue&type=script&lang=js"

import "./ContactSection.vue?vue&type=style&index=0&id=3d10ac53&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guifernandespro\\development\\projects\\vue_icon-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d10ac53"]])

export default __exports__